import { useCallback } from "react";
import { isAndroid, isWindows } from "react-device-detect";
import { useNavigate } from "react-router-dom";

export const useCommon = () => {
  const navigate = useNavigate();

  const onRedirect = useCallback(
    (url = "") =>
      () => {
        if (url.includes("https://")) {
          window.open(url, "_blank");
        } else {
          navigate(url);
        }
      },
    [navigate],
  );

  const downloadMT5App = useCallback(() => {
    let url = "";
    if (isAndroid) {
      url =
        "https://download.terminal.free/cdn/mobile/mt5/android?server=EmpireFX-Main%20Server";
    } else if (isWindows) {
      url =
        "https://download.terminal.free/cdn/web/empire.fx.trade/mt5/empirefx5setup.exe";
    } else {
      url =
        "https://download.terminal.free/cdn/mobile/mt5/ios?server=EmpireFX-Main%20Server";
    }
    onRedirect(url)();
  }, [onRedirect]);

  return { onRedirect, downloadMT5App };
};
